export const DELAYED_STABILITY = "DELAYED_STABILITY";
export const RHYTHMIC_INVERSION = "RHYTHMIC_INVERSION";
export const DENSITY_THINNING = "DENSITY_THINNING";
export const EVOLVING_THINNING = "EVOLVING_THINNING";
export const EMERGENT_CYCLES = "EMERGENT_CYCLES";
export const PROPABILISTIC_TRANSITIONS = "PROPABILISTIC_TRANSITIONS";
export const RHYTHMIC_PHASING = "RHYTHMIC_PHASING";
